import { panelConstants } from "../constants/panel.constants";
import {panelService} from "../services/panel.service";

function getMenu() {
    return dispatch => {
        dispatch(request());
        panelService.getMenu()
            .then(
                menu => {
                    dispatch(success(menu));
                },
                error => {
                    dispatch(failure());
                    console.log(error);
                }
            )
    };

    function request() { return { type: panelConstants.MENU_REQUEST } }
    function success(menu) { return { type: panelConstants.MENU_SUCCESS, menu} }
    function failure(error) { return {type: panelConstants.MENU_FAILURE, error} }
}

export const panelActions = {
    getMenu,
};
